export default __webpack_public_path__ + "static/media/google-icon.0e381c62.svg";